import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToasterService } from 'angular5-toaster/dist';
import { PeopleSurveyAnswerModel } from '../../../models/survey/survey.model';
import { SurveyService } from '../../../routes/surveys/surveys.service';

@Component({
  selector: 'app-word-cloud-rawtext-popup',
  templateUrl: './word-cloud-rawtext-popup.component.html',
  styleUrls: ['./word-cloud-rawtext-popup.component.less']
})
export class WordCloudRawtextPopupComponent implements OnInit {

  @Input() questionId: number;
  @Output() showLoader: boolean;
  @Input() showClipboard: boolean;
  dataSourceOrigin: PeopleSurveyAnswerModel[];
  enableCopyBtn: boolean;
  @Output() infoChange = new EventEmitter<boolean>();
  isMouseDown = false;

  constructor(private toasterService: ToasterService, private surveyService: SurveyService) { }

  ngOnInit() {
    const self = this;
    self.showLoader = true;
    self.surveyService.getSurveyAnswersWordCloud(this.questionId).subscribe(
      (response) => {
        self.dataSourceOrigin = response;
        self.showLoader = false;
        self.showClipboard = true;
        self.enableCopyBtn = false;
      },
      (error) => {
        self.showLoader = false;
      }
    );
  
  }
  
  close() {
    this.infoChange.emit(false);
  }

  closeRawTextModal() {
    this.showClipboard = false;
    this.infoChange.emit(false);
  }

  selectAll() {
    window.getSelection()
      .selectAllChildren(
        document.getElementsByClassName('clipboard-show')[0]
      );
      this.enableCopyBtn = true;
  }
  copyText(){
    document.execCommand('copy');
    this.toasterService.pop('success', 'Copy successful');
  }
  mouseUp(){
    if (this.showClipboard) {
      this.enableCopyBtn = this.getSelectionText() !== '';
    } else {
      this.enableCopyBtn = false;
    }
  }

  getSelectionText() {
    let text = '';
    if (window.getSelection) {
        text = window.getSelection().toString();
    } else if (document.getSelection() && document.getSelection().type != "Control") {
        text = document.getSelection().toString();
    }
    return text;
  }
  clearTheSelection() {
    if (this.isMouseDown) {
      if (window.getSelection) {
        if (window.getSelection().empty) {  // Chrome
          window.getSelection().empty();
        } else if (window.getSelection().removeAllRanges) {  // Firefox
          window.getSelection().removeAllRanges();
        }
      } else if (document.getSelection()) {  // IE?
        document.getSelection().empty;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/word-cloud-rawtext-popup/word-cloud-rawtext-popup.component.ts